import dayjs from 'dayjs';

export const autocompleteFields = [
  'list',
  'enumeration',
  'user',
  'project',
  'tracker',
  'issue_status',
  'issue_priority',
  'timesheet_issue',
  'issue_parent',
  'tags',
];
export const numberFields = ['float', 'progressbar', 'int'];
export const handleField = (data, field, deleted = false) => {
  let changedField = {
    valueId: data,
    valueName: data,
    changed: true,
  };
  field.fieldDefinition.fieldFormat === 'date' &&
    (changedField = {
      ...changedField,
      valueId: data ? dayjs(data.$d).format('YYYY-MM-DD') : null,
      valueName: data ? dayjs(data.$d).format('YYYY-MM-DD') : null,
    });
  field.fieldDefinition.fieldFormat === 'attachment' &&
    data &&
    (changedField = {
      ...changedField,
      valueId: data.token,
      valueName: data.fileName,
    });

  deleted &&
    (changedField = {
      ...changedField,
      valueId: '',
      valueName: '',
      deleted: true,
    });
  return changedField;
};

export const formatFields = fields => {
  let standards = [];
  let customs = [];
  fields.standards && (standards = fields.standards);
  fields.customs && (customs = fields.customs);
  const formattedCustoms = customs.map(field => ({ ...field, custom: true }));
  const allFields = standards.concat(formattedCustoms);
  return allFields.map(item => {
    let field = item;
    if (autocompleteFields.includes(field.fieldDefinition.fieldFormat)) {
      if (field.fieldDefinition.isMultiple) {
        if (field.valueId) {
          field = {
            ...field,
            valueId: field.fieldDefinition.values.filter(
              item => item.isChecked,
            ),
            valueName: field.fieldDefinition.values.filter(
              item => item.isChecked,
            ),
          };
        } else {
          field = {
            ...field,
            valueId: [],
            valueName: [],
          };
        }
      } else {
        if (field.valueId) {
          field = {
            ...field,
            valueId: { valueId: field.valueId, valueName: field.valueName },
            valueName: { valueId: field.valueId, valueName: field.valueName },
          };
        }
      }
    }

    return field;
  });
};

export const saveFormat = fields => {
  return fields.standards.concat(fields.customs).reduce(
    (acc, field) => {
      let value = field.valueId;
      field.fieldDefinition.fieldFormat === 'date' &&
        field.valueId === '' &&
        (value = null);
      if (
        field.valueId &&
        numberFields.includes(field.fieldDefinition.fieldFormat)
      ) {
        value = field.valueId.toString().includes(',')
          ? Number(field.valueId.replace(',', '.'))
          : Number(field.valueId);
      }
      field.fieldDefinition.fieldFormat === 'bool' &&
        (value = field.valueId === 'true');
      if (autocompleteFields.includes(field.fieldDefinition.fieldFormat)) {
        if (field.fieldDefinition.isMultiple) {
          value = field.valueId.map(item =>
            field.fieldDefinition.fieldFormat === 'tags'
              ? item.valueName
              : item.valueId,
          );
        } else {
          if (field.valueId) {
            !field.custom && (value = Number(field.valueId.valueId));
            field.custom && (value = field.valueId.valueId.toString());
          } else {
            value = field.valueId;
          }
        }
      }
      if (field.custom) {
        !Array.isArray(value) &&
          (value = value != null ? value.toString() : '');
        acc.customs.push({
          fieldId: field.fieldId,
          valueId: value ? value : '',
        });
      } else {
        acc[field.fieldId] = value;
      }
      return acc;
    },
    { customs: [] },
  );
};

export const sortOptions = (options, field) => {
  let values = null;
  let concatOptions = [];
  field.value &&
    field.value.selectedItems &&
    (values = field.value.selectedItems);
  field.values && Array.isArray(field.values) && (values = field.values);
  if (values) {
    const selectedItems = values.map(item =>
      item.fieldId ? item.fieldId : item,
    );
    const clearedOptions = options.filter(
      item =>
        !selectedItems.includes(item.fieldId ? item.fieldId : item.valueId),
    );
    const selectedOptions = options.filter(item =>
      selectedItems.includes(item.fieldId ? item.fieldId : item.valueId),
    );
    field.value && (concatOptions = values);
    field.values && (concatOptions = selectedOptions);
    return concatOptions.concat(clearedOptions);
  } else {
    return options;
  }
};
